<template>
<div >
	
	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class=" container" v-if="!loading">	
			
			
			<div class="card mt-2">
				<div class="card-body">

					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<router-link tag="li" to="/clients" class="breadcrumb-item active">Clientes</router-link>
						</ol>
						<div class="title">
							<h1>{{client.name}}</h1>
						</div>
						<div class="cta">
						</div>
					</div>

		
					<b-tabs>
						<b-tab title="Tarifas para vehículos" active>		
							<h5 class="card-title mt-4 mb-4">Tarifas para vehículos</h5>

							<div class="d-flex">
								<b-form-group label="Dep. Fiscal p/día" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.carPriceStayDayFiscal" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
								
								<b-form-group label="Dep. Nacional p/día" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.carPriceStayDay" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
								
								<b-form-group label="Estadía mínima" class="mb-3">
									<div class="input-group" style="width:120px;">
										<vue-numeric 
											separator="," 
											v-model="form.carPriceStayMinDays" 
											class="form-control text-right" 
											:precision="0" ></vue-numeric>
										<div class="input-group-append">
											<span class="input-group-text">dias</span>
										</div>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							</div>

							<b-form-group label="Costo por pre entrega" class="mb-3">
								<div class="input-group" style="width:120px;">
									<div class="input-group-prepend">
										<span class="input-group-text">U$S</span>
									</div>
									<vue-numeric 
										separator="," 
										v-model="form.carPricePreDelivery" 
										class="form-control text-right" 
										:precision="2" ></vue-numeric>
								</div>
								<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
							</b-form-group>
							
							<div class="d-flex">
								<b-form-group label="Aceite de motor Narfta" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.carPriceMotorOilGasoline" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							
								<b-form-group label="Aceite de motor Diesel" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.carPriceMotorOilGasoil" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							
								<b-form-group label="Liquido de caja de cambios" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.carPriceGearboxOil" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							
								<b-form-group label="Liquido de diferencial" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.carPriceDifferentialOil" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							</div>

							<div class="d-flex">
								<b-form-group label="Pulido por pieza" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.carPricePolishedPiece" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							
								<b-form-group label="Pulido total" class="mb-3">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.carPricePolishedTotal" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							</div>

							<b-form-group label="Carga de gas" class="mb-3">
								<div class="input-group" style="width:120px;">
									<div class="input-group-prepend">
										<span class="input-group-text">U$S</span>
									</div>
									<vue-numeric 
										separator="," 
										v-model="form.carPriceGasCharge" 
										class="form-control text-right" 
										:precision="2" ></vue-numeric>
								</div>
								<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
							</b-form-group>
						</b-tab>

						<b-tab title="Tarifas para camiones">

							<h5 class="card-title mt-4 mb-4">Tarifas para camiones</h5>

							<div class="d-flex">
								<b-form-group label="Dep. Fiscal p/día" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.truckPriceStayDayFiscal" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>

								<b-form-group label="Dep. Nacional p/día" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.truckPriceStayDay" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
								
								<b-form-group label="Estadía mínima" class="mb-3">
									<div class="input-group" style="width:120px;">
										<vue-numeric 
											separator="," 
											v-model="form.truckPriceStayMinDays" 
											class="form-control text-right" 
											:precision="0" ></vue-numeric>
										<div class="input-group-append">
											<span class="input-group-text">dias</span>
										</div>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							</div>

							<b-form-group label="Costo por pre entrega" class="mb-3">
								<div class="input-group" style="width:120px;">
									<div class="input-group-prepend">
										<span class="input-group-text">U$S</span>
									</div>
									<vue-numeric 
										separator="," 
										v-model="form.truckPricePreDelivery" 
										class="form-control text-right" 
										:precision="2" ></vue-numeric>
								</div>
								<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
							</b-form-group>
							
							<div class="d-flex">
								<b-form-group label="Aceite de motor Narfta" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.truckPriceMotorOilGasoline" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							
								<b-form-group label="Aceite de motor Diesel" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.truckPriceMotorOilGasoil" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							
								<b-form-group label="Liquido de caja de cambios" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.truckPriceGearboxOil" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							
								<b-form-group label="Liquido de diferencial" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.truckPriceDifferentialOil" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							</div>

							<div class="d-flex">
								<b-form-group label="Pulido por pieza" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.truckPricePolishedPiece" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							
								<b-form-group label="Pulido total" class="mb-3">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.truckPricePolishedTotal" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							</div>

							<b-form-group label="Carga de gas" class="mb-3">
								<div class="input-group" style="width:120px;">
									<div class="input-group-prepend">
										<span class="input-group-text">U$S</span>
									</div>
									<vue-numeric 
										separator="," 
										v-model="form.truckPriceGasCharge" 
										class="form-control text-right" 
										:precision="2" ></vue-numeric>
								</div>
								<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
							</b-form-group>

						</b-tab>
						
						
						<b-tab title="Tarifas para máquinas">

							<h5 class="card-title mt-4 mb-4">Tarifas para camiones</h5>

							<div class="d-flex">
								<b-form-group label="Dep. Fiscal p/día" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.machinePriceStayDayFiscal" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>

								<b-form-group label="Dep. Nacional p/día" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.machinePriceStayDay" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
								
								<b-form-group label="Estadía mínima" class="mb-3">
									<div class="input-group" style="width:120px;">
										<vue-numeric 
											separator="," 
											v-model="form.machinePriceStayMinDays" 
											class="form-control text-right" 
											:precision="0" ></vue-numeric>
										<div class="input-group-append">
											<span class="input-group-text">dias</span>
										</div>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							</div>

							<b-form-group label="Costo por pre entrega" class="mb-3">
								<div class="input-group" style="width:120px;">
									<div class="input-group-prepend">
										<span class="input-group-text">U$S</span>
									</div>
									<vue-numeric 
										separator="," 
										v-model="form.machinePricePreDelivery" 
										class="form-control text-right" 
										:precision="2" ></vue-numeric>
								</div>
								<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
							</b-form-group>
							
							<div class="d-flex">
								<b-form-group label="Aceite de motor Narfta" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.machinePriceMotorOilGasoline" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							
								<b-form-group label="Aceite de motor Diesel" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.machinePriceMotorOilGasoil" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							
								<b-form-group label="Liquido de caja de cambios" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.machinePriceGearboxOil" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							
								<b-form-group label="Liquido de diferencial" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.machinePriceDifferentialOil" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							</div>

							<div class="d-flex">
								<b-form-group label="Pulido por pieza" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.machinePricePolishedPiece" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							
								<b-form-group label="Pulido total" class="mb-3">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.machinePricePolishedTotal" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
							</div>

							<b-form-group label="Carga de gas" class="mb-3">
								<div class="input-group" style="width:120px;">
									<div class="input-group-prepend">
										<span class="input-group-text">U$S</span>
									</div>
									<vue-numeric 
										separator="," 
										v-model="form.machinePriceGasCharge" 
										class="form-control text-right" 
										:precision="2" ></vue-numeric>
								</div>
								<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
							</b-form-group>

						</b-tab>
					</b-tabs>

					<div class="overflow-hidden mt-3">
						<b-button type="button" @click="update()" class="pull-right" size="sm" variant="primary">Guardar cambios</b-button>
					</div>
	
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'
import Navbar from '@/components/Navbar'

export default {
	name: 'ClientFares',
	mixins:[mixins],
	props: ['clientId'],
	components:{
		Loader,
		Navbar
	},
	data () {
		return {
			loading: true,
			form:{
				carPriceStayDay:	0,
				carPriceStayDayFiscal:	0,
				carPriceStayMinDays:	0,
				carPricePreDelivery:	0,
				carPriceMotorOilGasoline:	0,
				carPriceMotorOilGasoil:	0,
				carPriceGearboxOil:	0,
				carPriceDifferentialOil:	0,
				carPricePolishedPiece:	0,
				carPricePolishedTotal:	0,
				carPriceGasCharge:	0,

				truckPriceStayDay:	0,
				truckPriceStayDayFiscal:	0,
				truckPriceStayMinDays:	0,
				truckPricePreDelivery:	0,
				truckPriceMotorOilGasoline:	0,
				truckPriceMotorOilGasoil:	0,
				truckPriceGearboxOil:	0,
				truckPriceDifferentialOil:	0,
				truckPricePolishedPiece:	0,
				truckPricePolishedTotal:	0,
				truckPriceGasCharge:	0,

				machinePriceStayDay:	0,
				machinePriceStayDayFiscal:	0,
				machinePriceStayMinDays:	0,
				machinePricePreDelivery:	0,
				machinePriceMotorOilGasoline: 0,
				machinePriceMotorOilGasoil:	0,
				machinePriceGearboxOil:	0,
				machinePriceDifferentialOil:0,
				machinePricePolishedPiece:	0,
				machinePricePolishedTotal:	0,
				machinePriceGasCharge:	0
			},
			client: {}
		}
	},
	beforeMount(){
		if( this.$route.params.id > 0 ){
			this.load(this.$route.params.id)
		}else{
			this.$router.go(-1)
		}
	},
	methods:{
		load(id){
			this.$apollo.query({
				query: gql`query  ($id: ID){
					client (id: $id) {
						id
		 				name
						fares{
							
							carPriceStayDay
							carPriceStayDayFiscal
							carPriceStayMinDays
							carPricePreDelivery
							carPriceMotorOilGasoline
							carPriceMotorOilGasoil
							carPriceGearboxOil
							carPriceDifferentialOil
							carPricePolishedPiece
							carPricePolishedTotal
							carPriceGasCharge

							truckPriceStayDay
							truckPriceStayDayFiscal
							truckPriceStayMinDays
							truckPricePreDelivery
							truckPriceMotorOilGasoline
							truckPriceMotorOilGasoil
							truckPriceGearboxOil
							truckPriceDifferentialOil
							truckPricePolishedPiece
							truckPricePolishedTotal
							truckPriceGasCharge
							
							machinePriceStayDay
							machinePriceStayDayFiscal
							machinePriceStayMinDays
							machinePricePreDelivery
							machinePriceMotorOilGasoline
							machinePriceMotorOilGasoil
							machinePriceGearboxOil
							machinePriceDifferentialOil
							machinePricePolishedPiece
							machinePricePolishedTotal
							machinePriceGasCharge
						}
					}
				}`,
				variables: {
					id: id,
				},
			})
			.then((data) => {
				this.client = data.data.client
				if(data.data.client.fares){
					this.form = data.data.client.fares
				}
				this.loading = false
			})
		},
		update () {
			var dataInput = {
				carPriceStayDay:		 	this.form.carPriceStayDay,
				carPriceStayDayFiscal:		 this.form.carPriceStayDayFiscal,
				carPriceStayMinDays:		this.form.carPriceStayMinDays,
				carPricePreDelivery:		this.form.carPricePreDelivery,
				carPriceMotorOilGasoline:	this.form.carPriceMotorOilGasoline,
				carPriceMotorOilGasoil:		this.form.carPriceMotorOilGasoil,
				carPriceGearboxOil:		 	this.form.carPriceGearboxOil,
				carPriceDifferentialOil:	this.form.carPriceDifferentialOil,
				carPricePolishedPiece:		this.form.carPricePolishedPiece,
				carPricePolishedTotal:		this.form.carPricePolishedTotal,
				carPriceGasCharge:			this.form.carPriceGasCharge,
				
				truckPriceStayDayFiscal:	this.form.truckPriceStayDayFiscal,
				truckPriceStayDay:		 	this.form.truckPriceStayDay,
				truckPriceStayMinDays:		this.form.truckPriceStayMinDays,
				truckPricePreDelivery:		this.form.truckPricePreDelivery,
				truckPriceMotorOilGasoline:	this.form.truckPriceMotorOilGasoline,
				truckPriceMotorOilGasoil:	this.form.truckPriceMotorOilGasoil,
				truckPriceGearboxOil:		this.form.truckPriceGearboxOil,
				truckPriceDifferentialOil:	this.form.truckPriceDifferentialOil,
				truckPricePolishedPiece:	this.form.truckPricePolishedPiece,
				truckPricePolishedTotal:	this.form.truckPricePolishedTotal,
				truckPriceGasCharge:		this.form.truckPriceGasCharge,
				
				machinePriceStayDayFiscal:	this.form.machinePriceStayDayFiscal,
				machinePriceStayDay:		this.form.machinePriceStayDay,
				machinePriceStayMinDays:	this.form.machinePriceStayMinDays,
				machinePricePreDelivery:	this.form.machinePricePreDelivery,
				machinePriceMotorOilGasoline: this.form.machinePriceMotorOilGasoline,
				machinePriceMotorOilGasoil:	this.form.machinePriceMotorOilGasoil,
				machinePriceGearboxOil:		this.form.machinePriceGearboxOil,
				machinePriceDifferentialOil:this.form.machinePriceDifferentialOil,
				machinePricePolishedPiece:	this.form.machinePricePolishedPiece,
				machinePricePolishedTotal:	this.form.machinePricePolishedTotal,
				machinePriceGasCharge:		this.form.machinePriceGasCharge,
			}
			this.$apollo.mutate({
				mutation: gql`mutation ( $client_id:ID!, $data:ClientFaresInput! ){
					clientFaresUpdate( client_id: $client_id, data: $data) {
						carPriceStayDayFiscal
						carPriceStayDay
						carPriceStayMinDays
						carPricePreDelivery
						carPriceMotorOilGasoline
						carPriceMotorOilGasoil
						carPriceGearboxOil
						carPriceDifferentialOil
						carPricePolishedPiece
						carPricePolishedTotal
						carPriceGasCharge
						
						truckPriceStayDayFiscal
						truckPriceStayDay
						truckPriceStayMinDays
						truckPricePreDelivery
						truckPriceMotorOilGasoline
						truckPriceMotorOilGasoil
						truckPriceGearboxOil
						truckPriceDifferentialOil
						truckPricePolishedPiece
						truckPricePolishedTotal
						truckPriceGasCharge

						machinePriceStayDayFiscal
						machinePriceStayDay
						machinePriceStayMinDays
						machinePricePreDelivery
						machinePriceMotorOilGasoline
						machinePriceMotorOilGasoil
						machinePriceGearboxOil
						machinePriceDifferentialOil
						machinePricePolishedPiece
						machinePricePolishedTotal
						machinePriceGasCharge
					}
				}`,
				variables: {
					client_id: this.$route.params.id,
					data: dataInput,
				}
			})
			.then(() => {
				this.$toast.success('Cambios guardados')
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		},
	}
}

</script>

<style scoped>

</style>
